// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Diligencias — page-specific styles: the pipeline board and its diligencia
   cards. Shared atoms (selbar, empty, tabs, tbl…) live in the base / primitive
   stylesheets; only what's unique to this screen lives here. */
/* A container query on .board could not restyle .board itself (an element
   establishes a container context for its descendants, not for its own
   box), so the query root is this wrapper one level up instead. Lets
   .board__col react to the space the sidebar leaves, not the viewport: a
   sidebar toggle changes this width without resizing the window, which a
   media query cannot see (REC-1793). */
.board-shell {
  container-type: inline-size;
}
.board {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-top: 14px;
}
.board__col {
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.board__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 2px 2px;
}
.board__n {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  margin-left: auto;
}
.board__cards {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.board__empty {
  font-family: var(--mono);
  font-size: var(--fs-sm);
  color: var(--text-muted);
  border: 1px dashed var(--border);
  padding: 16px;
  text-align: center;
}
.board__col--closed {
  border-left: 1px solid var(--border);
  padding-left: 12px;
}
.board__col--closed .dcard__partes {
  color: var(--text-secondary);
}
.dcard--closed {
  background: var(--bg-alt);
}
.board__more {
  margin-top: 2px;
  background: transparent;
  border: 1px dashed var(--border);
  color: var(--text-secondary);
  font-family: var(--mono);
  font-size: var(--fs-micro);
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 9px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition:
    border-color var(--dur-1) var(--ease),
    color var(--dur-1) var(--ease);
}
.board__more:hover {
  border-color: var(--text-muted);
  color: var(--text);
}
.board__more svg {
  stroke-width: 1.5;
}
.dcard {
  background: var(--surface);
  border: 1px solid var(--border);
  padding: 11px 12px;
  display: flex;
  flex-direction: column;
  gap: 7px;
  cursor: pointer;
  box-shadow: inset 3px 0 0 transparent;
  transition:
    border-color var(--dur-1) var(--ease),
    transform var(--dur-1) var(--ease),
    box-shadow var(--dur-1) var(--ease);
}
.dcard:hover {
  border-color: var(--text-muted);
  transform: translateY(-1px);
}
.dcard--ready {
  box-shadow: inset 3px 0 0 var(--accent);
}
.dcard--danger {
  box-shadow: inset 3px 0 0 var(--danger);
}
.dcard--warn {
  box-shadow: inset 3px 0 0 var(--warn);
}
.dcard--live {
  box-shadow: inset 3px 0 0 #1090ba;
}
.dcard--info {
  box-shadow: inset 3px 0 0 var(--info);
}
.dcard--mute {
  box-shadow: inset 3px 0 0 var(--text-muted);
}
.dcard__top {
  display: flex;
  align-items: center;
  gap: 9px;
}
/* The id (case rol) yields space to the deadline: real rols (C-6320-2026) can
   be long, so it shrinks + ellipses while the compact deadline keeps its full
   text (never clipped behind the card edge). */
.dcard__top .tbl__id {
  font-size: var(--fs-xs);
  min-width: 0;
  flex: 0 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dcard__vence {
  margin-left: auto;
  padding-left: 6px;
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
  font-size: var(--fs-xs);
  white-space: nowrap;
  flex: none;
}
.dcard__partes {
  font-size: var(--fs-detail);
  color: var(--text);
  line-height: 1.3;
}
.dcard__meta {
  font-size: var(--fs-xs);
  color: var(--text-muted);
}
.dcard__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border-top: 1px solid var(--border-soft);
  padding-top: 8px;
  margin-top: 1px;
}
.dcard__status {
  font-size: var(--fs-xs);
  color: var(--text-secondary);
}
.dcard .t-check {
  transform: scale(0.9);
}
.dcard--dense {
  padding: 8px 10px;
  gap: 5px;
}
.dcard--dense .dcard__meta {
  display: none;
}
.dcard--dense .dcard__foot {
  padding-top: 6px;
}

/* Below the width where a real card can show its full ROL (REC-1793:
   measured 950px — a 6-digit rol_number card truncates at 900px, fits at
   950px, 5 columns + 4×12px gaps), the lanes stack into one full-width
   column instead of narrowing past readability. A container query reacts to
   the board's own rendered width, so collapsing the sidebar (which frees
   width without resizing the viewport) is seen the same as a narrow window;
   a media query would miss the sidebar case entirely. */
@container (max-width: 950px) {
  .board {
    flex-direction: column;
  }
  .board__col {
    width: 100%;
  }
  /* Cards flow in a horizontal grid when a stacked lane has the width for
     more than one column; a single narrow viewport still gets one. */
  .board__cards {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 8px;
  }
  .board__empty {
    grid-column: 1 / -1;
    padding: 10px 16px;
  }
  /* FINALIZADA's divider separated it from the column beside it; stacked,
     it sits above the column below it instead. */
  .board__col--closed {
    border-left: none;
    border-top: 1px solid var(--border);
    padding-left: 0;
    padding-top: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/diligencias/Diligencias.css"],"names":[],"mappings":"AAAA;;+DAE+D;AAC/D;;;;;uCAKuC;AACvC;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR;;kCAEgC;AAClC;AACA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,qCAAqC;EACrC;;;uCAGqC;AACvC;AACA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,uCAAuC;AACzC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;;+CAE+C;AAC/C;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,QAAQ;AACV;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA;;;;;;wDAMwD;AACxD;EACE;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;qEACmE;EACnE;IACE,aAAa;IACb,4DAA4D;IAC5D,QAAQ;EACV;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;iDAC+C;EAC/C;IACE,iBAAiB;IACjB,mCAAmC;IACnC,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* Diligencias — page-specific styles: the pipeline board and its diligencia\n   cards. Shared atoms (selbar, empty, tabs, tbl…) live in the base / primitive\n   stylesheets; only what's unique to this screen lives here. */\n/* A container query on .board could not restyle .board itself (an element\n   establishes a container context for its descendants, not for its own\n   box), so the query root is this wrapper one level up instead. Lets\n   .board__col react to the space the sidebar leaves, not the viewport: a\n   sidebar toggle changes this width without resizing the window, which a\n   media query cannot see (REC-1793). */\n.board-shell {\n  container-type: inline-size;\n}\n.board {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  margin-top: 14px;\n}\n.board__col {\n  flex: 1 1 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.board__head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 0 2px 2px;\n}\n.board__n {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  margin-left: auto;\n}\n.board__cards {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.board__empty {\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  color: var(--text-muted);\n  border: 1px dashed var(--border);\n  padding: 16px;\n  text-align: center;\n}\n.board__col--closed {\n  border-left: 1px solid var(--border);\n  padding-left: 12px;\n}\n.board__col--closed .dcard__partes {\n  color: var(--text-secondary);\n}\n.dcard--closed {\n  background: var(--bg-alt);\n}\n.board__more {\n  margin-top: 2px;\n  background: transparent;\n  border: 1px dashed var(--border);\n  color: var(--text-secondary);\n  font-family: var(--mono);\n  font-size: var(--fs-micro);\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  padding: 9px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  transition:\n    border-color var(--dur-1) var(--ease),\n    color var(--dur-1) var(--ease);\n}\n.board__more:hover {\n  border-color: var(--text-muted);\n  color: var(--text);\n}\n.board__more svg {\n  stroke-width: 1.5;\n}\n.dcard {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  padding: 11px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  cursor: pointer;\n  box-shadow: inset 3px 0 0 transparent;\n  transition:\n    border-color var(--dur-1) var(--ease),\n    transform var(--dur-1) var(--ease),\n    box-shadow var(--dur-1) var(--ease);\n}\n.dcard:hover {\n  border-color: var(--text-muted);\n  transform: translateY(-1px);\n}\n.dcard--ready {\n  box-shadow: inset 3px 0 0 var(--accent);\n}\n.dcard--danger {\n  box-shadow: inset 3px 0 0 var(--danger);\n}\n.dcard--warn {\n  box-shadow: inset 3px 0 0 var(--warn);\n}\n.dcard--live {\n  box-shadow: inset 3px 0 0 #1090ba;\n}\n.dcard--info {\n  box-shadow: inset 3px 0 0 var(--info);\n}\n.dcard--mute {\n  box-shadow: inset 3px 0 0 var(--text-muted);\n}\n.dcard__top {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n}\n/* The id (case rol) yields space to the deadline: real rols (C-6320-2026) can\n   be long, so it shrinks + ellipses while the compact deadline keeps its full\n   text (never clipped behind the card edge). */\n.dcard__top .tbl__id {\n  font-size: var(--fs-xs);\n  min-width: 0;\n  flex: 0 1 auto;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.dcard__vence {\n  margin-left: auto;\n  padding-left: 6px;\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n  font-size: var(--fs-xs);\n  white-space: nowrap;\n  flex: none;\n}\n.dcard__partes {\n  font-size: var(--fs-detail);\n  color: var(--text);\n  line-height: 1.3;\n}\n.dcard__meta {\n  font-size: var(--fs-xs);\n  color: var(--text-muted);\n}\n.dcard__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  border-top: 1px solid var(--border-soft);\n  padding-top: 8px;\n  margin-top: 1px;\n}\n.dcard__status {\n  font-size: var(--fs-xs);\n  color: var(--text-secondary);\n}\n.dcard .t-check {\n  transform: scale(0.9);\n}\n.dcard--dense {\n  padding: 8px 10px;\n  gap: 5px;\n}\n.dcard--dense .dcard__meta {\n  display: none;\n}\n.dcard--dense .dcard__foot {\n  padding-top: 6px;\n}\n\n/* Below the width where a real card can show its full ROL (REC-1793:\n   measured 950px — a 6-digit rol_number card truncates at 900px, fits at\n   950px, 5 columns + 4×12px gaps), the lanes stack into one full-width\n   column instead of narrowing past readability. A container query reacts to\n   the board's own rendered width, so collapsing the sidebar (which frees\n   width without resizing the viewport) is seen the same as a narrow window;\n   a media query would miss the sidebar case entirely. */\n@container (max-width: 950px) {\n  .board {\n    flex-direction: column;\n  }\n  .board__col {\n    width: 100%;\n  }\n  /* Cards flow in a horizontal grid when a stacked lane has the width for\n     more than one column; a single narrow viewport still gets one. */\n  .board__cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n    gap: 8px;\n  }\n  .board__empty {\n    grid-column: 1 / -1;\n    padding: 10px 16px;\n  }\n  /* FINALIZADA's divider separated it from the column beside it; stacked,\n     it sits above the column below it instead. */\n  .board__col--closed {\n    border-left: none;\n    border-top: 1px solid var(--border);\n    padding-left: 0;\n    padding-top: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
